<template>

  <div class="patient-card " :class="questionNum > 0 ? 'has-question' : ''">
    <div v-if="data.day !== null && data.day !== undefined && isPeriod" class="day-info">
      <label :style="{ color: dayInfoColor }">
        {{ dayInfo }}
      </label>
    </div>
    <div v-if="questionNum > 0" class="day-info">
      <a-tooltip placement="topLeft">
        <template slot="title">
          该值为“已处理质疑数/质疑总数”，<label style="color: #E8B020">橙色数字</label>为系统质疑，<label style="color:red">红色数字</label>为人工质疑
        </template>
        <label style="color: red;margin-right: 5px;margin-left: 5px">
          {{ data.questionNum2 || 0 }}/{{ data.questionNum2Total || 0 }}
        </label>
        <label style="color: #E8B020;margin-right: 5px;margin-left: 5px">
          {{ data.questionNum1 || 0 }}/{{ data.questionNum1Total || 0 }}
        </label>
      </a-tooltip>

    </div>
    <a-row>
      <a-col :span="20">
        <div class="title-row">
          <div class="title">{{ data.centerName }}</div>
          <div class="title2">{{ data.personName }}</div>
        </div>
        <a-row class="info">
          <a-col :span="10">
            <div class="avatar-info">
              <a-avatar :size="64" :src="require('@/assets/head/' + (data.sex === '0' ? 'woman' : 'man') + '.jpg')" />
            </div>
            <div class="avatar-info" style="margin-top: 15px;margin-left: 3px">
              <status-tag :status="data.status"></status-tag>
            </div>
            <div class="avatar-info" style="margin-top: 15px;margin-left: 3px">
               <a-tag :color="'blue'">{{ data.inPeriodItemName||'无' }}</a-tag>
            </div>
          </a-col>
          <a-col :span="14">
            <div class="title row">
              <a-space>
                <div>
                  {{ data.patientNum }}
                </div>
                <div :style="{ color: data.sex === '0' ? '#ff5128' : '#2290ff' }" style="font-weight: normal;font-size: 12px">
                  {{ data.sex === '0' ? '女' : data.sex === '1' ? '男' : '-' }}</div>
                <div style="margin-left: 5px;font-weight: normal;font-size: 12px;width: 40px">{{ data.age }}岁</div>
              </a-space>
            </div>
            <div class="title row ">
              <a-tooltip class="info-row">
                <template slot="title">
                  {{ data.name }}
                </template>
                <div class="one-row name">
                  <strong v-if="groupName===''">{{ data.name }}</strong>  
                  <strong v-else :style="{ color: '#007fff'  }">{{ data.name }}-{{ groupName }}</strong>
                </div>
              </a-tooltip>
            </div>
            <a-row :gutter="10">
              <template v-for="(item, index) in defineFieldList">
                <a-tooltip>
                  <template slot="title">
                    {{ data.defineField[item.id] }}
                  </template>
                  <a-col :span="24" class="row info-mini one-row" :key="index" v-if="index < 4">
                    {{ item.name }}：{{ data.defineField[item.id] }}
                  </a-col>
                </a-tooltip>
              </template>
              <template v-for="(item, index) in periodGroupList">
                <a-tooltip>
                  <template slot="title">
                    {{ item.groupName }}：{{ item.status==="1"?'手术期':item.status==="2"?'已终止':'戴牙后' }}
                  </template>
                  <a-col :span="12" class="row info-mini one-row" :key="index" v-if="index < 4">
                    {{ item.groupName }}：{{ item.status==="1"?'手术期':item.status==="2"?'已终止':'戴牙后' }}
                  </a-col>
                </a-tooltip>
              </template>
            </a-row>
            <!--<div class="row">-->
            <!--{{pad==='0'?data.createTime:data.createTime.substring(0,10)}}-->
            <!--</div>-->
          </a-col>
        </a-row>
        <div class="form-info">
          <label>{{ pad === '0' ? data.createTime : data.createTime.substring(0, 10) }}</label>
          <label style="margin-left: 20px">表单数：{{ data.formSubmitSum }}/{{ data.formSum }}</label>
        </div>
        <div class="row" style="margin-top: -5px">
          <a-progress :percent="formProgress">
          </a-progress>
        </div>
        <!-- <div class="row" style="margin-top: -5px">
          <a-progress :percent="formNormalProgress">
            <template #format="percent">
              <span v-if="formNormalProgress < 94">{{ formNormalProgress }}%</span>
              <span style="color: green;font-weight: bold" v-else>{{ formNormalProgress }}%</span>
            </template>
          </a-progress>
        </div> -->
      </a-col>
      <a-col :span="4" v-if="isRegister">
        <div class="btn btn1" @click="editClick" v-has="'patient:modify'">
          编<br />辑
        </div>
        <div class="btn btn3" @click="viewClick">
          查<br />看
        </div>
      </a-col>
      <a-col :span="4" v-else>
        <div class="btn btn2" @click="viewClick">
          查<br />看
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import StatusTag from './StatusTag'
export default {
  name: 'PatientCard',
  components: { StatusTag },
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    },
    pad: {
      type: String,
      default: '0'
    },
    fieldList: {
      default: []
    },
    isRegister: {
      type: Boolean,
      default: true
    },
    isPeriod: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
    }
  },
  watch: {
    data() {
    }
  },
  computed: {
    groupName() {
      if (this.data.rctStatus==='1') {
        return '待定'
      }else if(this.data.rctStatus==='2'){
        const rctConfig = JSON.parse(this.data.rctConfig)
        let rctContent=rctConfig.rctGroup
        if(rctConfig.rctInterfere.status==='0'){
          rctContent+='-完成'
        }else{
           rctContent+='-未完成'
        }
        return rctContent
      }else{
        return ''
      }
    },
    questionNum() {
      return (this.data.questionNum1Total | 0) + (this.data.questionNum2Total || 0)
    },
    dayInfo() {
      if (this.data.day >= 0) {
        return `还剩(${this.data.day})天`
      }
      else if (this.data.day < 0) {
        return `已超期(${Math.abs(this.data.day)})天`
      }
      return ''
    },
    dayInfoColor() {
      if (this.data.day > 0) {
        return `green`
      }
      if (this.data.day >= 0) {
        return `#E8B020`
      }
      else if (this.data.day < 0) {
        return `red`
      }
    },
    formProgress() {
      const rate = ((this.data.formSubmitSum || 0) / (this.data.formSum || 100)) * 100
      return parseFloat(rate.toFixed(2))
    },
    formNormalProgress() {
      const rate = ((this.data.formNormalSubmitSum || 0) / (this.data.formSum || 100)) * 100
      return parseFloat(rate.toFixed(2))
    },
    defineFieldList() {
      const list = []
      this.fieldList.forEach(item => {
        if (item.type === '2'&& item.isShow=='1') {
          list.push(item)
        }
      })
      return list
    },
    periodGroupList(){
      const list = []
      if(this.data.periodGroups && this.data.periodGroups.length>0)
        return this.data.periodGroups.slice(0, 3)      
      return list
    },
  },
  mounted() {
  },
  methods: {
    editClick() {
      this.$emit('editClick', this.data)
    },
    viewClick() {
      this.$emit('viewClick', this.data)
    }
  }
}
</script>

<style scoped lang="less">
.has-question {
  border-radius: 7px;
  border: solid 1px red !important;
}

.patient-card {
  box-shadow: 3px 3px 6px #888888;
  border-radius: 7px;
  border: solid 1px rgba(0, 0, 0, 0.2px);
  min-height: 200px;
  padding: 10px;

  .day-info {
    position: absolute;
    top: -10px;
    right: 10px;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    z-index: 1;
  }

  .title-row {
    height: 25px;

    .title {
      float: left;
      font-weight: bold;
    }

    .title2 {
      float: right;
      font-weight: bold;
      margin-right: 10px;
    }
  }

  .info {
    .title {
      font-weight: bold;
      font-size: 16px;
    }

    .row {
      margin-bottom: 0px;
    }

    .name {
      height: 25px;
    }
  }

  .avatar-info {
    width: 100%;
    text-align: center;
  }

  .form-info {
    text-align: center;
    font-size: 14px;
  }

  .btn1 {
    margin-top: -10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  .btn3 {
    margin-bottom: -10px;
  }

  .btn {
    margin-right: -10px;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-left: 20px;
    line-height: 34px;
    text-align: center;
    font-size: 16px;
    color: @primary-color;
    border-left: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0px;
    cursor: pointer;
  }

  .btn2 {
    margin-top: -10px;
    line-height: 79px;
  }

  .btn:hover {
    /*border: 1px solid #40a9ff;*/
    background-color: rgba(0, 0, 0, 0.1);
    font-weight: bold;
  }
}

.info-mini {
  font-size: 12px;
}
</style>